import { useLocation, matchPath } from "react-router-dom";
import { useJobProgress } from "../../../contexts/JobProgressContext";
import JobProgressToast from "./JobProgressNotification";

const GlobalJobProgress = () => {
  const { activeJobs } = useJobProgress();
  const location = useLocation();

  // Plan id from the plan-details route (/planVersion/:id), or null on any other page.
  const currentPlanId = matchPath("/planVersion/:id", location.pathname)?.params?.id ?? null;

  // Copy plan/actuals jobs are plan-scoped (they carry planIds): only show their progress bar
  // while the matching plan's details page is open, and hide it when the user leaves.
  // All other job types (COA GL-code upload, auto-mapping, value-template upload) carry no
  // planIds and keep showing globally as before.
  const visibleJobs = activeJobs.filter((job) => {
    const planIds = job.planIds || [];
    if (planIds.length === 0) return true;
    return currentPlanId != null && planIds.map(String).includes(String(currentPlanId));
  });

  if (visibleJobs.length === 0) return null;

  return (
    <div className="flex flex-col gap-3 items-end">
      {visibleJobs.map((job) => (
        <JobProgressToast
          key={job.jobId}
          jobId={job.jobId}
          progressData={{ progress: job.progress, message: job.message, jobId: job.jobId, status: job.status, tracked: job.tracked }}
        />
      ))}
    </div>
  );
};

export default GlobalJobProgress;
